 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_CONTENTS from '@/components/html/03_CONTENTS'
 import HTML04_PREFACE from '@/components/html/04_PREFACE'
 import HTML05_ABBREVIATIONS_AND_MATTERS_OF_CIT from '@/components/html/05_ABBREVIATIONS_AND_MATTERS_OF_CIT'
 import HTML06_INTRODUCTION from '@/components/html/06_INTRODUCTION'
 import HTML07_ABOUT_THE_TRANSLATION from '@/components/html/07_ABOUT_THE_TRANSLATION'
 import HTML08_A_NOTE_ON_THE_TEXT from '@/components/html/08_A_NOTE_ON_THE_TEXT'
 import HTML09_TUSCULAN_DISPUTATIONS from '@/components/html/09_TUSCULAN_DISPUTATIONS'
 import HTML10_BOOK_3 from '@/components/html/10_BOOK_3'
 import HTML11_BOOK_4 from '@/components/html/11_BOOK_4'
 import HTML12_COMMENTARY from '@/components/html/12_COMMENTARY'
 import HTML13_BOOK_3__ON_GRIEF from '@/components/html/13_BOOK_3__ON_GRIEF'
 import HTML14_BOOK_4__ON_EMOTIONS from '@/components/html/14_BOOK_4__ON_EMOTIONS'
 import HTML15_APPENDIXES__SOURCES_FOR_CICERO_S from '@/components/html/15_APPENDIXES__SOURCES_FOR_CICERO_S'
 import HTML16_APPENDIX_A__CRANTOR_AND_THE_CONS from '@/components/html/16_APPENDIX_A__CRANTOR_AND_THE_CONS'
 import HTML17_APPENDIX_B__EPICURUS_AND_THE_CYR from '@/components/html/17_APPENDIX_B__EPICURUS_AND_THE_CYR'
 import HTML18_APPENDIX_C__THE_EARLY_STOICS_AND from '@/components/html/18_APPENDIX_C__THE_EARLY_STOICS_AND'
 import HTML19_APPENDIX_D__POSIDONIUS from '@/components/html/19_APPENDIX_D__POSIDONIUS'
 import HTML20_BIBLIOGRAPHY from '@/components/html/20_BIBLIOGRAPHY'
 import HTML21_INDEX_LOCORUM from '@/components/html/21_INDEX_LOCORUM'
 import HTML22_GENERAL_INDEX from '@/components/html/22_GENERAL_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/03_CONTENTS",
 			"name" : "html/03_CONTENTS",
 			"component" : HTML03_CONTENTS
 		},
 		{
 			"path" : "/html/04_PREFACE",
 			"name" : "html/04_PREFACE",
 			"component" : HTML04_PREFACE
 		},
 		{
 			"path" : "/html/05_ABBREVIATIONS_AND_MATTERS_OF_CIT",
 			"name" : "html/05_ABBREVIATIONS_AND_MATTERS_OF_CIT",
 			"component" : HTML05_ABBREVIATIONS_AND_MATTERS_OF_CIT
 		},
 		{
 			"path" : "/html/06_INTRODUCTION",
 			"name" : "html/06_INTRODUCTION",
 			"component" : HTML06_INTRODUCTION
 		},
 		{
 			"path" : "/html/07_ABOUT_THE_TRANSLATION",
 			"name" : "html/07_ABOUT_THE_TRANSLATION",
 			"component" : HTML07_ABOUT_THE_TRANSLATION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js